import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription, ReplaySubject } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers'
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class CompaniesProvider implements OnInit, OnDestroy {
  // companies: Observable<any>;
  _companiesObs: Observable<any>;
  public companies: any[];
  companiesSubscription: Subscription;

  broadcast = new ReplaySubject();

  constructor(
    public store: Store<fromRoot.State>
  ) {
    this._companiesObs = this.store.select(fromRoot.getCompanies).filter(v => v.length > 0);
    console.log('Companies provider');
  }
  ngOnInit() {

    this.companiesSubscription = this.store.select(fromRoot.getCompanies).filter(v => v.length > 0).subscribe((state: any[]) => {
      this.companies = state;
      this.broadcast.next(state);
      console.log('Companies:', state);
    });

  }

  ngOnDestroy() {
    this.companiesSubscription.unsubscribe();
  }

  get(): any[] {
    return this.companies;
  }

}



// WEBPACK FOOTER //
// ./src/providers/companies/companies.ts